import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { registration } from './registration.reducer';
import { user } from './user.reducer';
import { design } from './design.reducer';
import { resource } from './resource.reducer';
import { template } from './template.reducer';
import { graphicBuilder } from './graphicBuilder.reducer';
import { subscription } from './subscription.reducer';
import { referral } from './referral.reducer';
import { coupon } from './coupon.reducer';
import { payment } from './payment.reducer';
import { plan } from './plan.reducer';
import { role } from './role.reducer';
import { dashboard } from './dashboard.reducer';

const rootReducer = combineReducers({
  authentication,
  registration,
  user,
  design,
  resource,
  template,
  graphicBuilder,
  subscription,
  referral,
  coupon,
  payment,
  plan,
  role,
  dashboard,
});

export default rootReducer;
